import React, { useState } from "react";
import { ApiEndpoint } from "../../utils/ApiEndpoint.js";
import { Stack, Button } from "react-bootstrap";

import * as AiIcons from "react-icons/ai";
import EditCustomer from "./EditCustomer";
import ModalEdit from "../../components/ModalEdit.js";
import { Link } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext.js";
import { httpClient } from "../../utils/HttpClient.js";
import { useQuery } from "@tanstack/react-query";
import { Table } from "../../components/ui/Table";
const URI = ApiEndpoint + "customers/";

const Customers = () => {
  const Auth = useAuth();
  const userData = Auth.getSessionData();
  const [show, setShow] = useState(false);

  const [idCustomer, setIdCustomer] = useState(0);

  const {
    isFetching: isPending,
    data: customers,
    refetch,
  } = useQuery({
    queryKey: ["customers"],
    queryFn: async () => {
      const response = await httpClient("GET", URI, {}, userData.token);

      return await response.data;
    },
    refetchOnWindowFocus: false,
    initialData: [],
  });

  const handleClose = () => {
    refetch();
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const columns = [
    {
      accessor: "idcustomer",
      Header: "#",
    },
    {
      accessor: "name",
      Header: "Nombre",
    },
    {
      accessor: "comercialname",
      Header: "Nombre Comercial",
    },
    {
      accessor: "rfc",
      Header: "RFC",
    },
    {
      accessor: "none",
      Header: "Acciones",
      disableSortBy: true,
      headerProps: {
        className: "text-center",
      },
      cellProps: {
        className: "text-center",
      },
      Cell: (rowData) => {
        let customer = rowData.row.original;
        return (
          <>
            <AiIcons.AiOutlineEdit
              className="IconTable"
              onClick={() => {
                setIdCustomer(customer.idcustomer);
                handleShow();
              }}
            />
            <Link to={"/Customer/Details/" + customer.uidCustomer}>
              <AiIcons.AiOutlineSearch
                className="IconTable"
                title="Detalles"
                onClick={""}
              />
            </Link>
            <AiIcons.AiOutlineDelete className="IconTable" />
          </>
        );
      },
    },
  ];
  return (
    <>
      <div>
        <Stack direction="horizontal" gap={2} className="AlignItemsTop">
          <div>
            <h2>Clientes</h2>
            <h3>Administre la lista de clientes.</h3>
          </div>
          <div className="ms-auto">
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setIdCustomer(0);
                setShow(true);
              }}
            >
              <AiIcons.AiOutlinePlus /> Agregar
            </Button>{" "}
          </div>
        </Stack>
        <div className="bg-white px-4 py-2 rounded-lg">
          <Table
            data={customers}
            columns={columns}
            isLoading={isPending}
            config={{
              search: true,
              pagination: true,
              pageSize: 10,
              perPage: 10,
              footer: true,
            }}
          />
        </div>
      </div>
      <ModalEdit
        show={show}
        handleShow={handleShow}
        handleClose={handleClose}
        title={idCustomer > 0 ? "Editar Cliente" : "Agregar Cliente"}
      >
        <EditCustomer
          show={show}
          handleShow={handleShow}
          handleClose={handleClose}
          idCustomer={idCustomer}
        />
      </ModalEdit>
    </>
  );
};

export default Customers;
